export const breadcrumbComponent = {
  key: 'breadcrumbComponent',
  name: 'Breadcrumb Component',
  siteIdentifier: 'global',

  breadcrumbAriaLabel: 'Breadcrumb',
  shopBreadcrumbLabel: 'Shop',
};
